import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// import ListItemAvatar from "@material-ui/core/ListItemAvatar";
// import Avatar from "@material-ui/core/Avatar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import * as actions from "../../../store/actions";
import { CRICKET_SCORES } from "../../../config/games";
import { ACTION } from "../../../config/actions";
import i18n from "../../../i18n";
import DartSound from "../../DartSound/DartSound";
import { isCricketGame } from "../../../config/games";
import { THEMES_TYPE } from "../../../config/themes";
import { ScoreController } from "./scoreController";

import { REDUCER } from './scoreController'

const Ax = (props) => props.children;

class Scoreboard extends React.Component {
  SoundPlayer = null;

  Controller = null;

  constructor(props) {
    super(props);

    this.Controller = new ScoreController(props.gameType)

    this.state = {
      ...this.state,
      theme: props.theme,
      players: props.players,
      currentRound: props.currentRound,
      lastRound: props.lastRound,
      roundCount: props.roundCount,
      scoreMultiplier: 1,
      confirmReset: false,
    };
  }

  componentDidUpdate(previousProps) {
    const {
      action: { date: prevDate },
      target: { date: prevTargetDate },
    } = previousProps;
    const {
      action: { action, date },
      target: { date: targetDate, value, multiple },
    } = this.props;
    if (date !== prevDate) {
      this.handleKeyDown(action);
    }
    if (targetDate !== prevTargetDate) {
      this.handleKeyDown({ value, multiple });
    }
  }

  setScore = (value, multiple) => {


    let isSoundLoaded = false;


    const {
      currentRound: updatedRound,
      theme,
      roundCount,
    } = this.state;

    const { gameType } = this.props;

    if (updatedRound.scores.length < 3) {
      const { currentRound, scoreMultiplier, players, currentPlayerWinner } = this.Controller.calculateScores({ ...this.state }, value, multiple);

      this.setState({
        currentRound,
        scoreMultiplier,
        players,
        currentPlayerWinner
      });

      if (!isCricketGame(gameType)) {
        if (currentRound.currentScore < 0) {
          this.SoundPlayer.setTrack('loose', theme);
          isSoundLoaded = true;
        } else if (currentRound.currentScore === 0) {
          this.SoundPlayer.setTrack('win', theme);
          isSoundLoaded = true;
        }
      } else if (isCricketGame(gameType) && currentPlayerWinner) {
        this.endGame(players, players[currentRound.player], roundCount);
      }

      if (!isSoundLoaded) {
        this.setSoundPlayer(
          multiple === 3 ? "triple" : multiple === 2 ? "double" : "simple",
          theme
        )
      }
    }
  };

  nextRoundHandler = () => {
    const { currentRound, roundCount, players } = this.state;
    const { gameType } = this.props;
    const player = players[currentRound.player];

    let totalDarts = player.darts;

    if (currentRound.darts > 0) {
      totalDarts = player.darts + currentRound.darts;
    }

    // update the player stats
    const points = (player.points + currentRound.total) || 0;
    let updatedPlayer = {
      ...player,
      currentScore: currentRound.currentScore || 0,
      cricket: currentRound.cricket,
      points,
      darts: totalDarts,
      ppd: (points !== 0) ? (points / totalDarts) : 0,
    };
    updatedPlayer.history.push(currentRound.total || 0);

    // @todo: implémenter Type de jeu
    if (currentRound.currentScore < 0 && !isCricketGame(gameType)) {
      updatedPlayer = player;
    }

    //reset current round
    const numberPlayers = players.length;
    const nextPlayer = currentRound.player === numberPlayers - 1 ? 0 : currentRound.player + 1;

    const updatedPlayers = [...players];
    updatedPlayers[currentRound.player] = updatedPlayer;

    const nextRound = {
      player: nextPlayer,
      scores: [],
      total: 0,
      stats: {},
      currentScore: updatedPlayers[nextPlayer].currentScore,
      cricket: updatedPlayers[nextPlayer].cricket
    };

    const currentPlayerWinner = this.Controller.isWinner(updatedPlayers, currentRound.player)

    // @todo: implémenter Type de jeu
    if (updatedPlayer.currentScore === 0 && !isCricketGame(gameType)) {
      this.endGame(updatedPlayers, updatedPlayer, roundCount);
    } else if (isCricketGame(gameType) && currentPlayerWinner) {
      this.endGame(updatedPlayers, updatedPlayer, roundCount);
    } else {
      const updatedRoundCount = roundCount + 1;

      this.setState({
        ...this.state,
        players: updatedPlayers,
        currentRound: nextRound,
        lastRound: currentRound,
        roundCount: updatedRoundCount,
        currentPlayerWinner,
      });
    }
  };

  resetGameHandler = () => {
    this.setState({ confirmReset: true });
  };

  dismissConfirmHandler = () => {
    this.setState({ confirmReset: false });
  };

  resetGame = () => {
    this.props.resetGame();
  };

  changeTheme = (theme) => {

    if (!theme) {
      const value = THEMES_TYPE.findIndex(
        (props) => props.value === this.props.theme
      );
      theme =
        value === THEMES_TYPE.length - 1
          ? THEMES_TYPE[0].value
          : THEMES_TYPE[value + 1].value;

    }
    document.getElementById("body").className = `${theme}`;
    this.props.setTheme(theme);
  };

  endGame(players, winningPlayer, roundCount) {
    this.props.endGame(players, winningPlayer, roundCount);
  }

  handleKeyDown = (props) => {
    if (typeof props === "string") {
      if (this.state.confirmReset) {
        if (props === ACTION.START) {
          this.props.resetGame();
        } else if (props === ACTION.CANCEL) {
          this.dismissConfirmHandler()
        } else if (props === ACTION.OPTION) {
          this.changeTheme();
        }

      } else if (props === ACTION.START) {
        this.nextRoundHandler();
      } else if (props === ACTION.CANCEL) {
        this.resetGameHandler();
      }
    } else {
      const { value, multiple } = props;
      this.setScore(value, multiple);
    }
  }

  render() {

    const { confirmReset } = this.state;
    // Check if user is from Options page
    if (!this.props.isAuth) {
      return <Redirect to="/" />;
    }

    return (
      <div className="container scoreboard--container">
        {confirmReset && this.renderModalReset()}
        <div className="row">
          <div className="col-xs-7 text-center" id="block-table">
            {this.renderTableau()}
          </div>
          <div className="col-xs-5 text-center" id="block-graph">
            {this.renderHighChart()}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center" id="block-players">
            {this.renderPlayers()}
          </div>
        </div>
        <DartSound ref={(e) => (this.SoundPlayer = e)} key="contextSound" />
      </div>
    );
  }

  setSoundPlayer(track, theme) {
    if (this.SoundPlayer) {
      this.SoundPlayer.setTrack(track, theme);
    }
  }

  renderHighChart() {
    const { players } = this.state;
    const { availablePlayers } = this.props;
    const series = [];
    players.forEach((player, i) => {
      series.push({ data: player.history, name: availablePlayers[player.id] });
    });
    const options = {
      chart: {
        type: "spline",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: ""
      },
      series,
      credits: {
        enabled: false
      }
    };
    return (
      <HighchartsReact highcharts={Highcharts} options={options} />
    )
  }


  renderModalReset() {
    return (
      <div className="scoreboard__overlay">
        <div className="confirm-container">
          <h4>{i18n.t("SCOREBOARD.MODAL.MESSAGE_EXIT")}</h4>
          <div className="button-wrapper mt-12">
            <button
              className="button button--green mx-4"
              onClick={this.dismissConfirmHandler}
            >
              {i18n.t("BUTTON.CANCEL")}
            </button>
            <button
              className="button button--red mx-4 middle"
              onClick={this.changeTheme}
            >
              {i18n.t("BUTTON.CHANGE_THEME")}
            </button>

            <button
              className="button button--red mx-4"
              onClick={this.resetGame}
            >
              {i18n.t("BUTTON.RESET")}
            </button>
          </div>
        </div>
      </div>

    )
  }

  renderTitle() {
    return (
      <h1>
        {this.props.gameType} Game - Round {this.state.roundCount}
      </h1>
    );
  }

  renderPlayers() {
    const { players } = this.state;
    return (
      <List>{players.map(this.renderPlayer)}</List>
    );
  }

  renderStats() {
    // Displays scores of individual darts for current round
    let dartScores = null;
    // Set current player to display scores
    let currentPlayer = this.state.players[this.state.currentRound.player];

    if (this.state.currentRound.scores.length > 0) {
      const currentScores = this.state.currentRound.scores;
      const playerScore = this.state.players[this.state.currentRound.player]
        .score;

      if (currentScores.reduce(REDUCER) > playerScore) {
        dartScores = (
          <div>
            <div className="round__score w-full round__score--bust">
              <h3>Bust</h3>
            </div>
          </div>
        );
      } else if (currentPlayer.score - this.state.currentRound.total === 0) {
        dartScores = (
          <div>
            <div className="round__score w-full round__score--winner">
              <h3>Winner</h3>
            </div>
          </div>
        );
      } else {
        const length = this.state.currentRound.scores.length;
        const width =
          length === 0 || length === 1 ? "100%" : `${100 / length}%`;
        dartScores = (
          <Ax>
            {this.state.currentRound.scores.map((score, i) => (
              <div
                key={i}
                className="round__score"
                style={{
                  float: "left",
                  textAlign: "center",
                  margin: "0 auto",
                  width,
                }}
              >
                <h3>{score}</h3>
              </div>
            ))}
          </Ax>
        );
      }
    }
    return (
      <div className="stats">
        <h3>Round Score</h3>
        <h2 id="throws-left">{this.state.currentRound.total}</h2>
        {dartScores}
      </div>
    );
  }

  renderTableau() {
    const { players } = this.state;
    const widthScore = '30px';
    return (
      <TableContainer component={Paper}>
        <Table
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell />
              {players.map((a) => (
                <TableCell key={`tableCellHeader-${a.id}`} align="center">{`P${a.id + 1}`}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {CRICKET_SCORES.map((currentValue, j) => (
              <TableRow key={currentValue}>
                <TableCell key={`ref-${currentValue}`} style={{ width: widthScore }}>
                  {currentValue}
                </TableCell>
                {players.map((player, p) => (
                  <TableCell align="center" key={`tableCellBody${j}${p}`}>
                    {this.renderCricketCell(player, currentValue)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }


  renderCricketCell(player, currentValue) {
    let darts = [];

    let nbDarts = player.cricket[currentValue] || 0;
    nbDarts = nbDarts >= 3 ? 3 : nbDarts;
    for (let i = 0; i < nbDarts; i++) {
      darts.push(<span />)
    }
    return darts;
  }

  getValueCricket(value, player) {
    let nbCross = "";
    if (player.cricket) {
      const nbValues = player.cricket[value];
      if (nbValues > 0) {
        for (let i = 0; i < nbValues; i++) {
          nbCross += "x";
        }
      }
    }
    return nbCross;
  }

  renderPlayer = (player) => {
    let liveScore = player.currentScore || 0;
    let classCurrentPlayer = null;
    const { availablePlayers } = this.props;
    let darts = [];
    if (this.state.currentRound.player === player.id) {
      player = this.state.players[this.state.currentRound.player];
      liveScore = this.state.currentRound.currentScore;
      classCurrentPlayer = "current-player";

      const nbDarts = this.state.currentRound.darts || 0;
      for (let i = 0; i < nbDarts; i++) {
        darts.push(<span />)
      }
    }

    return (
      <ListItem alignItems="flex-start" className={classCurrentPlayer} key={`playerBoard-${player.id}`}>
        {/* <ListItemAvatar>
          <Avatar
            alt={`${availablePlayers[player.id] || i18n.t("SCOREBOARD.NO_USER")}`}
            src="/static/images/avatar/1.jpg"
          />
        </ListItemAvatar> */}
        <ListItemText
          primary={`${availablePlayers[player.id] || i18n.t("SCOREBOARD.NO_USER")}`}
          secondary={
            `${liveScore}`
          }
        />
        {player.ppd !== 0 && <div className="current-player-ppd">{player.ppd.toFixed(2)}</div>}
        <div className="current-player-darts">{darts}</div>
      </ListItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.scoreboard
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTheme: (options) => dispatch(actions.setTheme(options)),
    resetGame: () => dispatch(actions.resetGame()),
    endGame: (players, winningPlayer, roundCount) =>
      dispatch(actions.endGame(players, winningPlayer, roundCount)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Scoreboard);
